import Loader from "@common/components/Suspense/Loader";
import Grid from "@mui/material/Grid2";
import { Divider } from "@mui/material";
import React from "react";
import useRole from "../hooks/useRole";
import AdminPortalArea from "./AdminPortalArea";
import NameArea from "./NameArea";
import { useAuthenticatedUser } from "@services/user/hooks/useAuthenticatedUser";
import { canEditRole } from "@common/utils/user";

interface RoleFormProps {}

const RoleForm = ({}: RoleFormProps): React.JSX.Element => {
  const { isLoading } = useRole();
  const [user] = useAuthenticatedUser();
  const canEdit = canEditRole(user);

  if (isLoading) return <Loader />;
  return (
    <Grid
      container
      direction="column"
      sx={{ width: "100%", gap: 2, padding: 2 }}
    >
      <NameArea canEdit={canEdit} />
      <Divider />
      <AdminPortalArea canEdit={canEdit} />
    </Grid>
  );
};

export default RoleForm;
